import { createContext, useContext, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAccount } from '../redux/actions/account';
import { useUser } from './UserContext';
import { useGlobal } from './GlobalContext';

const AccountContext = createContext({
   accounts: [],
   incomeAccounts: [],
   account: null,
});

export const useAccount = () => useContext(AccountContext);

export const AccountProvider = ({ children }) => {
   const { user } = useUser();
   const { userGlobalSettingsData } = useGlobal();
   const accounts = useSelector((state) => state?.account?.list);
   const dispatch = useDispatch();
   const authToken = localStorage.getItem('authTokenCustomer');

   const isAccount = useMemo(
      () => userGlobalSettingsData?.[0]?.askCompany?.account || false || false,
      [userGlobalSettingsData],
   );

   const accountList = useMemo(() => {
      return accounts.filter((account) => ['K', 'E', 'C', 'D', 'BROKER', 'I', 'L', 'M', 'N', 'A'].includes(account.glGroupCode));
   }, [accounts]);

   useEffect(() => {
      if (user && user?.loginhistory?.companyId && authToken) {
         const payload = {
            compId: user?.loginhistory?.companyId,
            // accountTypes: 'K,E,C,D,BROKER,I,L,M,N,A',
            status: true,
            sortBy: 'name',
            sortOrder: 'asc',
         };
         if (isAccount) {
            payload.companyIds = user?.loginhistory?.companyId;
         }
         dispatch(getAccount(payload));
      }
   }, [user, dispatch, authToken, isAccount]);

   return <AccountContext.Provider value={{ accounts: accountList, incomeAccounts: accounts, account: null }}>{children}</AccountContext.Provider>;
};
